import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, withRouter } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { renderRoutes } from 'react-router-config';
import styled from 'styled-components';
import { Header, HeaderMobile } from '../../components'

import '../../styles/global';
import '../../styles/fonts';

class App extends Component {

    render() {

        return (
            <Container>

                <Helmet>
                    <link rel="stylesheet" type="text/css" href="https://rsms.me/inter/inter-ui.css" />
                    <link rel="icon" type="image/png" href="data:image/png;base64,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" />
                </Helmet>

                <Header/>
                <HeaderMobile/>

                {renderRoutes(this.props.route.routes)}

            </Container>
        );
    }
}

export default withRouter(App);

const Container = styled.div`
    height: 100%;
    overflow-x: hidden;
`



// WEBPACK FOOTER //
// ./client/modules/App/App.js